import React from 'react';
import { useSelector } from 'react-redux';
import { Fieldset, FormNumber, FormRadio, FormSelect } from '~/components/FormControl';
import { formLabel } from '~/utils/helpers';
import { Form } from 'react-bootstrap';

function FightCheck() {
    const { defendingSides } = useSelector((state) => state.heroSaga.trait);

    return (
        <Fieldset className={'px-2'}>
            <Fieldset.Legend>{formLabel('FightCheck')}</Fieldset.Legend>
            <Form.Row>
                <FormRadio
                    name="hasFirstStrike"
                    sm={6}
                />
                <FormSelect
                    name="defendingSide"
                    sm={6}
                    options={defendingSides}
                />
            </Form.Row>
            <Form.Row className="mt-3">
                <FormNumber
                    name="blockConditionAdded"
                    sm={6}
                />
                <FormNumber
                    name="strikeConditionAdded"
                    sm={6}
                />
            </Form.Row>
        </Fieldset>
    );
}

export default FightCheck;
